module.exports = __webpack_public_path__ + "img/timeline-graph-sm.e98f6b3c.svg";